import { useNavigate } from "react-router-dom";
import { AboutUsFooter } from "../features/dashboard/footerComponent";
import CFooter from "../layouts/footer/footer";
import CNavBar from "../layouts/Navbar";

const AboutUs = () => {
  const navigate = useNavigate();

  const setSignup = () => {
    navigate("/");
  };

  return (
    <>
      <CNavBar
        isButton={true}
        isbrandText={true}
        brandText={"Reachello"}
        brandTextStyle={{ color: "#044389", fontWeight: "bold" }}
        navBgColor={"white"}
        menuAlignment={"right"}
        buttonListArray={["Login"]}
        btnCustomStyle={{
          border: "1px solid black",
          backgroundColor: "white",
          color: "#044389",
        }}
        setAction={() => setSignup()}
        btnClasses={"px-4"}
        btnFontWeight={"bold"}
        spaceBetweenItems={5}
      />
      <AboutUsFooter />
      <CFooter
        copyRightBlockAlignment={"right"}
        copyRightTextAlignment={"right"}
      />
    </>
  );
};

export default AboutUs;
